export enum ServiceWorkerStatusEnum {
  READY = 'ready',
  REGISTERED = 'registered',
  CACHED = 'cached',
  UPDATE_FOUND = 'updatefound',
  UPDATED = 'updated',
  OFFLINE = 'offline',
  ERROR = 'error',

  // Workbow service worker lifecycle
  LOAD = 'load',
  INSTALL = 'install',
  ACTIVATE = 'activate',
}

export enum ServiceWorkerEventEnum {
  CACHED_VIDEO_DELETED,
  ALL_CACHED_VIDEO_DELETED,
  CACHED_VIDEO_ADDED,
}
